import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { useCart } from "../context/CartContext";


const API_URL = "https://apimyshop.myidealtd.co.uk";



/* ================= IMAGE HANDLER ================= */

const getImageUrl = (product) => {

  if (!product) {
    return "/images/no-image.png";
  }


  if (
    product.images &&
    product.images.length > 0 &&
    product.images[0].main
  ) {

    return `${API_URL}${product.images[0].main}`;

  }


  return "/images/no-image.png";

};





function BestSeller() {


  const { addToCart, cart } = useCart();


  const safeCart =
    Array.isArray(cart)
      ? cart
      : [];



  const [products,setProducts] = useState([]);

  const [loading,setLoading] = useState(true);

  const [error,setError] = useState("");

  const [quickView,setQuickView] = useState(null);



  const [darkMode,setDarkMode] = useState(
    localStorage.getItem("darkMode")==="true"
  );





  useEffect(()=>{

    localStorage.setItem(
      "darkMode",
      darkMode
    );

  },[darkMode]);






  /* ================= LOAD BEST SELLERS ================= */


  useEffect(()=>{


    const fetchProducts = async()=>{


      try{


        const res =
        await axios.get(
          `${API_URL}/api/products`
        );



        console.log(
          "FULL API RESPONSE:",
          res.data
        );



        const allProducts =
        Array.isArray(res.data)
        ?
        res.data
        :
        res.data.products || [];



        console.log(
          "ALL PRODUCTS:",
          allProducts
        );




        const bestSellerProducts =
        allProducts.filter((p)=>{


          return (

            p.bestSeller === true ||
            p.bestSeller === "true" ||

            p.features?.bestSeller === true ||
            p.features?.bestSeller === "true"

          );


        });




        console.log(
          "BEST SELLERS:",
          bestSellerProducts
        );



        setProducts(
          bestSellerProducts
        );



      }
      catch(err){


        console.error(
          "BEST SELLER ERROR:",
          err
        );


        setError(
          "Failed to load Best Seller products."
        );


      }
      finally{


        setLoading(false);


      }



    };



    fetchProducts();



  },[]);







  /* ================= CART ================= */


  const handleAdd = (product)=>{


    const already =
    safeCart.some(
      item =>
      item._id === product._id
    );



    if(already)
      return;



    addToCart(product);


  };







  /* ================= LOADING ================= */


  if(loading){


    return (

      <div

      style={{

        height:"100vh",

        display:"flex",

        justifyContent:"center",

        alignItems:"center"

      }}

      >

        <Spinner animation="border"/>

      </div>

    );


  }







  return (


<div

style={{

background:

darkMode

?

"#020617"

:

"#f5f7fb",


minHeight:"100vh",

paddingBottom:"50px"

}}

>




<Button

onClick={()=>
setDarkMode(!darkMode)
}

style={{

position:"fixed",

right:"20px",

bottom:"20px",

zIndex:9999,

borderRadius:"999px",

border:"none",

background:
darkMode
?
"#fff"
:
"#111827",

color:
darkMode
?
"#111827"
:
"#fff"

}}

>

{
darkMode
?
"☀️"
:
"🌙"
}

</Button>








<Container fluid className="py-5">





<div className="text-center mb-5">


<div

style={{

display:"inline-block",

padding:"8px 20px",

borderRadius:"999px",

background:
"linear-gradient(135deg,#f59e0b,#fbbf24)",

color:"#fff",

fontWeight:700

}}

>

⭐ BEST SELLERS

</div>






<h1

style={{

marginTop:"20px",

fontWeight:900,

color:
darkMode
?
"#fff"
:
"#111827"

}}

>

Best Sellers

</h1>






<p

style={{

color:
darkMode
?
"#cbd5e1"
:
"#6b7280"

}}

>

Our customers' favourite products.

</p>



</div>









<Row className="g-4">


{
products.map((p)=>(


<Col
lg={3}
md={6}
key={p._id}
>


<Card

style={{

border:"none",

borderRadius:"28px",

overflow:"hidden",

height:"100%",

background:
darkMode
?
"#111827"
:
"#fff",

boxShadow:
"0 15px 40px rgba(0,0,0,.10)",

transition:"0.3s"

}}

>




<div
style={{
position:"relative"
}}

>



<div

style={{

position:"absolute",

top:"15px",

left:"15px",

zIndex:2,

background:"#f59e0b",

color:"#fff",

padding:"7px 15px",

borderRadius:"999px",

fontSize:"12px",

fontWeight:700

}}

>

⭐ BEST SELLER

</div>





<Link
to={`/product/${p._id}`}
>


<img

src={getImageUrl(p)}

alt={p.name}



onError={(e)=>{

e.target.src =
"/images/no-image.png";

}}



style={{

width:"100%",

height:"260px",

objectFit:"contain",

padding:"20px",

background:
darkMode
?
"#0f172a"
:
"#f8fafc"

}}

/>



</Link>


</div>








<Card.Body>


<h5

style={{

fontWeight:700,

color:
darkMode
?
"#fff"
:
"#111827"

}}

>

{p.name}

</h5>






<h4

style={{

color:"#f59e0b"

}}

>

£{p.price}

</h4>






<Button

className="w-100"

onClick={()=>
handleAdd(p)
}

>

Buy Now

</Button>







<Button

variant="light"

className="w-100 mt-2"

onClick={()=>
setQuickView(p)
}

>

Quick View

</Button>




</Card.Body>



</Card>



</Col>


))

}



</Row>









{
products.length===0 &&

<div

className="text-center mt-5"

style={{

color:
darkMode
?
"#fff"
:
"#111827"

}}

>

<h3>
No Best Seller products available
</h3>


<p>
Please mark products as Best Seller from Admin.
</p>


</div>

}







{
error &&

<p

className="text-danger text-center"

>

{error}

</p>

}




</Container>









<Modal

show={!!quickView}

onHide={()=>
setQuickView(null)
}

centered

>


{

quickView &&

<>


<Modal.Header closeButton>

<Modal.Title>

{quickView.name}

</Modal.Title>


</Modal.Header>





<Modal.Body>



<img

src={getImageUrl(quickView)}

alt={quickView.name}



onError={(e)=>{

e.target.src =
"/images/no-image.png";

}}



style={{

width:"100%",

borderRadius:"20px"

}}

/>






<h3 className="mt-3">

£{quickView.price}

</h3>





<p>

{quickView.description}

</p>



</Modal.Body>


</>


}


</Modal>







</div>


);


}


export default BestSeller;